// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__20QsM","title":"FrontImage_title__yKFQq"};